import { render, staticRenderFns } from "./deliveryPlans.vue?vue&type=template&id=19908434&scoped=true&"
import script from "./deliveryPlans.vue?vue&type=script&lang=js&"
export * from "./deliveryPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19908434",
  null
  
)

export default component.exports